import Vue from 'vue'
import VueAxios from './plugins/axios'
import VueCookies from 'vue-cookies'
import VueMeta from 'vue-meta'

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap'
import './styles/styles.scss'

import App from './App.vue'
import router from './router'
import i18n from './i18n'

// Make global variable $vueAssets available throughout the application. It's used to reference the external directory where assets are stored.
Vue.prototype.$siteTitle = 'Ontario Newsroom'
Vue.prototype.$vueAssets = process.env.VUE_APP_ASSETS

Vue.use(VueAxios)
Vue.use(VueCookies)
Vue.use(VueMeta)

Vue.config.productionTip = false

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')